import { useEffect, useState } from "react";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

import styles from "./InstallApp.module.scss";
import { useLocation } from "react-router-dom";
import { PRODUCT_NAME } from "../../utils/environment";

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  const location = useLocation();
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    if (!isMobile) return;
    if (location.pathname !== "/home") return;

    // Check if popup was already shown
    const alreadyShown = localStorage.getItem("installPromptShown");
    if (alreadyShown) return;

    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, [isMobile, location.pathname]);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === "accepted") {
      console.log("User accepted install");
    } else {
      console.log("User dismissed install");
    }

    localStorage.setItem("installPromptShown", "true");

    setDeferredPrompt(null);
    setShowPopup(false);
  };

  const handleClose = () => {
    setDeferredPrompt(null);
    setShowPopup(false);
    localStorage.setItem("installPromptShown", "true");
  };

  return (
    <>
      {deferredPrompt && (
        <Dialog
          maxWidth="lg"
          open={showPopup}
          onClose={() => {
            handleClose();
          }}
          aria-labelledby="install-dialog-title"
          aria-describedby="install-dialog-description"
        >
          <DialogContent className={styles.installAppContainer}>
            <h2>Install App</h2>
            <div id="install-dialog-description">
              <div>
                <img src="/images/install-app.jpg" alt="Install App" />
              </div>
              <div className={styles.message}>Install {PRODUCT_NAME} app on your device for a faster and more reliable experience.</div>

              <div className={styles.buttonBlock}>
                <button onClick={handleInstallClick}>Install Now!</button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
